var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: _vm.title || _vm.form.id ? "编辑" : "创建",
        width: 870,
        visible: _vm.visible,
        destroyOnClose: "",
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: { span: 3 },
              wrapperCol: { span: 20 },
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _vm.currKeysFormArr.includes("title")
              ? _c(
                  "a-form-model-item",
                  { attrs: { label: "标题", prop: "title" } },
                  [
                    _c("a-input", {
                      attrs: { placeholder: "请输入标题" },
                      model: {
                        value: _vm.form.title,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "title", $$v)
                        },
                        expression: "form.title",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.currKeysFormArr.includes("applicableGrade") &&
            _vm.currKeysFormArr.includes("classify")
              ? _c(
                  "a-form-model-item",
                  { attrs: { label: "选择分类", prop: "classify" } },
                  [
                    _c("j-dict-select-tag", {
                      attrs: {
                        placeholder: "请选择分类",
                        dictCode: _vm.cateDictCode,
                        allowClear: "",
                      },
                      model: {
                        value: _vm.form.classify,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "classify", $$v)
                        },
                        expression: "form.classify",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.currKeysFormArr.includes("applicableGrade") &&
            _vm.currKeysFormArr.includes("classify")
              ? _c(
                  "a-row",
                  { staticStyle: { padding: "0 20px" }, attrs: { gutter: 0 } },
                  [
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: "适用年级",
                              prop: "applicableGrade",
                              labelCol: { ..._vm.itemLabelCol },
                              wrapperCol: _vm.itemWrapperCol,
                            },
                          },
                          [
                            _c("j-dict-select-tag", {
                              attrs: {
                                placeholder: "请选择年级",
                                dictCode: _vm.gradeDictCode,
                                allowClear: "",
                              },
                              model: {
                                value: _vm.form.applicableGrade,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "applicableGrade", $$v)
                                },
                                expression: "form.applicableGrade",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-col",
                      { attrs: { span: 12 } },
                      [
                        _c(
                          "a-form-model-item",
                          {
                            attrs: {
                              label: "选择分类",
                              prop: "classify",
                              labelCol: _vm.itemLabelCol,
                              wrapperCol: _vm.itemWrapperCol,
                            },
                          },
                          [
                            _c("j-dict-select-tag", {
                              attrs: {
                                placeholder: "请选择分类",
                                dictCode: _vm.cateDictCode,
                                allowClear: "",
                              },
                              model: {
                                value: _vm.form.classify,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "classify", $$v)
                                },
                                expression: "form.classify",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.currKeysFormArr.includes("cover")
              ? _c(
                  "a-form-model-item",
                  { attrs: { label: "上传封面", prop: "cover" } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-align-center" },
                      [
                        _c("j-image-upload", {
                          ref: "coverRef",
                          attrs: {
                            accept: ".png,.jpg,.jpeg",
                            bizPath: _vm.bizPath,
                          },
                          on: { change: _vm.imgChange },
                          model: {
                            value: _vm.form.cover,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "cover", $$v)
                            },
                            expression: "form.cover",
                          },
                        }),
                        _c("span", { staticStyle: { color: "#cdcdcd" } }, [
                          _vm._v("*建议封面尺寸444 * 252，大小不超过500kb"),
                        ]),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm.currKeysFormArr.includes("courseDesc")
              ? _c(
                  "a-form-model-item",
                  { attrs: { label: "简介", prop: "courseDesc" } },
                  [
                    _c("a-textarea", {
                      attrs: {
                        placeholder: "请输入简介",
                        "auto-size": { minRows: 3, maxRows: 5 },
                      },
                      model: {
                        value: _vm.form.courseDesc,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "courseDesc", $$v)
                        },
                        expression: "form.courseDesc",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.currKeysFormArr.includes("file")
              ? _c(
                  "a-form-model-item",
                  { attrs: { label: "附件", prop: "file" } },
                  [
                    _c(
                      "div",
                      { staticClass: "flex-align-center" },
                      [
                        _c("JUpload", {
                          attrs: {
                            accept: this.acceptSuffix,
                            fileType: "file",
                            value: _vm.filePath,
                            bizPath: _vm.bizPath,
                          },
                          on: { change: _vm.fileChange },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "10px",
                              color: "#cdcdcd",
                            },
                          },
                          [
                            _vm._v(
                              "\n            *" +
                                _vm._s(
                                  this.acceptSuffix === ".zip"
                                    ? "仅可上传zip压缩包"
                                    : "仅可上传文档和PPT"
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm.currKeysFormArr.includes("content")
              ? _c(
                  "a-form-model-item",
                  { attrs: { label: "详细介绍", prop: "content" } },
                  [
                    _c("WangEditor", {
                      staticStyle: {
                        margin: "2px",
                        border: "1px solid #d9d9d9",
                        "border-radius": "4px",
                        overflow: "hidden",
                      },
                      attrs: { editorStyle: { minHeight: "200px" } },
                      model: {
                        value: _vm.form.content,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "content", $$v)
                        },
                        expression: "form.content",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }